import howWeProtectYouImage from './images/how-we-protect-you.svg';
import protectYourselfImage from './images/protect-yourself.svg';
import robotImage from './images/robot.svg';

export const HOW_WE_PROTECT_YOU_TILE = {
  ctas: [
    {
      link: 'https://ahm.com.au/explained/how-we-protect-you',
      linkText: "Find out how we're protecting you",
      variant: ['wide'],
    },
  ],
  image: {
    alt: '',
    src: howWeProtectYouImage.src,
  },
  subtitle:
    'We work with cybersecurity experts to protect our systems and keep your personal and health information safe.',
  title: 'How we protect you',
};

export const HOW_TO_PROTECT_YOURSELF = {
  ctas: [
    {
      link: 'https://ahm.com.au/explained/how-to-protect-yourself',
      linkText: 'Tips for protecting yourself',
      variant: ['wide'],
    },
  ],
  image: {
    alt: '',
    src: protectYourselfImage.src,
  },
  subtitle: 'Keep your information safe with these handy tips and resources.',
  title: 'How to protect yourself',
};

export const SCAMS_TILE = {
  ctas: [
    {
      link: 'https://ahm.com.au/explained/scams',
      linkText: 'Learn about common scams',
      variant: ['wide'],
    },
  ],
  image: {
    alt: '',
    src: robotImage.src,
  },
  subtitle: 'When you know how to spot common scams, you can be prepared when they come your way.',
  title: 'Scams',
};
